import Offer from '../../types/Offer.interface';


const offerActionBuilderFactory = (
  { client, propertyId, handleRefreshedOffer }: {
    client: any,
    propertyId: string,
    handleRefreshedOffer: (offer: Offer) => void
  }) => (
  offer: Offer,
) => {
  const actions = [];
  if (offer.enabled === false) {
    actions.push({
      label: 'Enable',
      action: async () => {
        await client.properties.for(propertyId).businesses.for(offer.businessId).offers.for(offer.id).enable();
        return handleRefreshedOffer({
          ...offer,
          enabled: true,
          status: 'scheduled',
        });
      },
    });
  }
  return actions;
};

export default offerActionBuilderFactory;
